// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg width=%2714%27 height=%272%27 viewBox=%270 0 14 2%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M0 0h14v2H0z%27 fill=%27%23FFF%27 fill-rule=%27evenodd%27/></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ShowListingDetails_title__bVIVy {
  font-size: 36px;
  margin: 0 0 48px;
  text-align: center;
}
@media (max-width: 767px) {
  .ShowListingDetails_title__bVIVy {
    font-size: 24px;
  }
}

.ShowListingDetails_subTitle__RB32P {
  color: #4a4a4f;
  font-size: 28px;
  margin: 48px 0 24px;
}
@media (max-width: 767px) {
  .ShowListingDetails_subTitle__RB32P {
    font-size: 20px;
  }
}

.ShowListingDetails_listingDetailsWrapper__deeSz p,
.ShowListingDetails_listingDetailsWrapper__deeSz label,
.ShowListingDetails_listingDetailsWrapper__deeSz li,
.ShowListingDetails_listingDetailsWrapper__deeSz h6,
.ShowListingDetails_listingDetailsWrapper__deeSz h1 {
  color: #4a4a4f;
  word-break: break-word;
}
@media (max-width: 767px) {
  .ShowListingDetails_listingDetailsWrapper__deeSz p {
    font-size: 14px;
  }
}

.ShowListingDetails_selectMenu__D4-kX {
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.5px;
  border-top: 1px solid rgba(128, 128, 128, 0.159);
}
.ShowListingDetails_selectMenu__D4-kX:nth-child(1) {
  border-top: none;
}
.ShowListingDetails_selectMenu__D4-kX img {
  height: 40px;
  width: 40px;
  border-radius: 100px;
  object-fit: cover;
  margin: 4px 0;
}
.ShowListingDetails_selectMenu__D4-kX .ShowListingDetails_genreText__5Ia3X {
  font-size: 12px;
  margin-top: 6px;
}

.ShowListingDetails_multiSelectBox__AGKTa {
  position: relative;
  z-index: 11;
}
.ShowListingDetails_multiSelectBox__AGKTa > div {
  border-radius: 6px;
  /* border: 1px solid var(--Web-H-3, #538ABE); */
  color: var(--Black-Shade-Text_Black, #272727);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  border-color: #b9b9b9;
  padding: 1px 8px;
  /* &:not(:last-child) {
    min-height: 61px;
    @media (max-width: 767px) {
      min-height: 36px;
    }
  } */
}
.ShowListingDetails_multiSelectBox__AGKTa > div > div {
  /* padding: 5px 8px; */
}
.ShowListingDetails_multiSelectBox__AGKTa > div input {
  height: auto;
  color: var(--Black-Shade-Text_Black, #272727);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.ShowListingDetails_multiSelectBox__AGKTa > div input:focus {
  box-shadow: none;
}

.css-1jqq78o-placeholder {
  color: var(--Black-Shade-Text_Black, #272727) !important;
}
.css-1jqq78o-placeholder::placeholder {
  color: var(--Black-Shade-Text_Black, #272727) !important;
}

.css-t3ipsp-control {
  min-height: 48px !important;
}
@media (max-width: 767px) {
  .css-t3ipsp-control {
    min-height: 36px !important;
  }
}

.css-13cymwt-control {
  min-height: 48px !important;
  border: 1px solid #d8dce6 !important;
}
@media (max-width: 767px) {
  .css-13cymwt-control {
    min-height: 36px !important;
  }
}

.css-1nmdiq5-menu {
  position: relative !important;
  z-index: 12 !important;
}

.ShowListingDetails_timeInputs__U6GnX {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 8px;
}
.ShowListingDetails_timeInputs__U6GnX select {
  color: gray;
  font-size: 16px;
}
.ShowListingDetails_timeInputs__U6GnX > div {
  width: calc(50% - 12px);
}
.ShowListingDetails_timeInputs__U6GnX svg {
  vertical-align: middle;
  fill: #484848;
  height: 24px;
  width: 24px;
}

.ShowListingDetails_boldText__8dCyW {
  font-weight: 700;
}

.ShowListingDetails_reasonLabel__NWyxk {
  font-size: 16px;
  font-weight: 700;
}

.ShowListingDetails_blur__awEp9 {
  color: transparent;
  text-shadow: 0 0 8px #000;
}

.Toastify__close-button {
  width: -moz-fit-content !important;
  width: fit-content !important;
  margin: 0 !important;
}

.ShowListingDetails_socialContents__qclxh {
  display: flex;
  gap: 20px;
}
@media (max-width: 767px) {
  .ShowListingDetails_socialContents__qclxh {
    gap: 16px;
  }
}
.ShowListingDetails_socialContents__qclxh .ShowListingDetails_socialContent__SP4IB {
  display: flex;
}
@media (max-width: 767px) {
  .ShowListingDetails_socialContents__qclxh .ShowListingDetails_socialContent__SP4IB svg {
    width: 28px;
    height: 28px;
  }
}
.ShowListingDetails_socialContents__qclxh .ShowListingDetails_socialContent__SP4IB .ShowListingDetails_socialText__pxTQX {
  margin-bottom: 16px;
  font-size: 18px;
  margin-right: 12px;
  font-weight: 600;
}
@media (max-width: 1023px) {
  .ShowListingDetails_socialContents__qclxh .ShowListingDetails_socialContent__SP4IB .ShowListingDetails_socialText__pxTQX {
    margin-bottom: 8px;
    font-size: 16px;
  }
}

.ShowListingDetails_linkText__1cOZE {
  color: #4646f3;
  font-size: 18px;
  word-break: break-all;
  font-weight: 600;
}
@media (max-width: 1023px) {
  .ShowListingDetails_linkText__1cOZE {
    font-size: 16px;
  }
}

.ShowListingDetails_contentWrapper__NfXEp {
  display: flex;
  gap: 30px;
  margin: 48px 0;
  min-height: 300px;
}
@media (max-width: 1023px) {
  .ShowListingDetails_contentWrapper__NfXEp {
    flex-direction: column;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX {
  width: calc(100% - 548px);
}
@media (max-width: 1023px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX {
    width: 100%;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_artistTitle__tXYb- {
  font-size: 40px;
  color: #4a4a4f;
  margin-bottom: 6px;
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_artistTitle__tXYb- {
    font-size: 28px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_artistName__ax3iH {
  color: #4a4a4f;
  font-size: 24px;
  margin: 16px 0 36px;
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_artistName__ax3iH {
    font-size: 18px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_venueTag__DkLqW {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 36px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_artistBio__POJXK {
  font-size: 18px;
  margin: 0px 0 10px;
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX .ShowListingDetails_artistBio__POJXK {
    font-size: 16px;
    margin: 0px 0 6px;
  }
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX h1 {
    font-size: 24px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX h2 {
  margin: 36px 0 12px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX h3 {
  margin: 24px 0 16px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX ul {
  list-style: unset;
  margin-left: 20px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_leftContents__jG3nX ul li {
  margin-bottom: 6px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG {
  width: 500px;
  margin-left: 48px;
  background: rgb(242, 242, 240);
  padding: 48px 36px;
  border-radius: 16px;
  height: -moz-fit-content;
  height: fit-content;
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  /* Add an underline for '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
  /* Remove default bg-color and use our extra span instead '.renderedDay' */
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG {
    width: 460px;
  }
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG {
    padding: 12px;
    width: 100%;
    margin-left: 0;
    background: none;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_bookButton__u4FP8 {
  background-color: #064749;
  color: #fff;
  border-radius: 100px;
  margin-top: 24px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_bookButton__u4FP8:disabled {
  opacity: 0.4;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_calendlyButton__MCuFg {
  background-color: #064749;
  color: #fff;
  border-radius: 100px;
  margin-top: 16px;
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_calendlyButton__MCuFg {
    margin-top: 12px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_calendlyButton__MCuFg a {
  text-decoration: none;
  color: #fff;
  width: 100%;
  height: 100%;
  display: block;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG h6 {
  font-size: 20px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContent__sQM4h {
  display: flex;
  align-items: center;
  margin: 16px 0;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK {
  margin: 0 0 32px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK h6 {
  font-size: 22px;
  margin-bottom: 8px;
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK h6 {
    font-size: 18px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK h1 {
  margin-bottom: 24px;
  margin-top: 36px;
}
@media (max-width: 767px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK h1 {
    font-size: 24px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK p {
  margin-bottom: 12px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_orderContents__n6pgK ul {
  margin-left: 24px;
  margin-bottom: 12px;
  list-style: disc;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_registeredText__7Ady1 {
  color: red;
  text-align: center;
  margin: 16px 0;
  font-size: 14px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .ShowListingDetails_calenderText__SANPT {
  margin-bottom: 8px !important;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateRangePicker {
  display: block;
  margin-bottom: 16px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateRangePicker_picker__directionLeft {
  /* !important is added to top because react-dates uses inline style for height */
  /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */
  box-shadow: var(--boxShadowButton);
  top: 36px !important;
  left: unset !important;
  width: calc(100% - 48px);
  background-color: #064749;
}
@media (min-width: 768px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateRangePicker_picker__directionLeft {
    /* !important is added to top because react-dates uses inline style for height */
    /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */
    top: 48px !important;
    left: 0px !important;
    width: 100%;
    min-height: calc(100vh - 252px);
    min-height: auto;
    border-radius: 0 0 6px 6px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateInput_input {
  font-family: var(--fontFamily);
  font-weight: var(--fontWeightMedium);
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.1px;
  display: block;
  width: 100%;
  padding: 6px 12px 4px;
  margin: 0;
  border-radius: 6px;
  border: 1px solid #d8dce6;
  background-color: #fff;
  outline: none;
  transition: all 0.1s ease-in-out;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateInput_input:focus {
  border-radius: 6px 6px 0 0;
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  transition: all ease-in-out 100ms;
}
@media (min-width: 768px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateInput_input {
    line-height: 32px;
    padding: 7px 16px;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateRangePickerInput {
  width: 100%;
  display: flex;
  justify-content: space-between;
  border: none;
  background-color: transparent;
  align-items: center;
  gap: 8px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPicker__horizontal {
  margin: 0 auto;
  background-color: #064749;
  box-shadow: none;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPickerNavigation__horizontal {
  position: relative;
  width: 100%;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPickerNavigation_button__horizontal {
  padding: 6px 9px;
  top: 16px;
  position: absolute;
  cursor: pointer;
  display: inline;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPickerNavigation_button__horizontal:first-of-type {
  left: 24px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPickerNavigation_button__horizontal:last-of-type {
  right: 24px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPickerNavigation_button {
  color: #fff;
  border: 0;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarMonth, .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarMonthGrid {
  background-color: transparent;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateInput {
  display: block;
  width: 100%;
  background: transparent;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPicker_weekHeader {
  color: #fff;
  top: 57px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPicker_weekHeader_li {
  font-weight: var(--fontWeightRegular);
  color: #fff;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPicker_weekHeader_ul_1 {
  margin: 10px 0 0 !important;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DayPicker__withBorder {
  border-radius: 0;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarMonth_caption {
  font-weight: var(--fontWeightRegular);
  font-size: 21px;
  line-height: 24px;
  color: #fff;
  margin: 1px 0 14px;
}
@media (min-width: 768px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarMonth_caption {
    line-height: 32px;
    margin-top: 0;
    margin-bottom: 0;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__default {
  background-color: #064749;
  border: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay {
  font-weight: var(--fontWeightMedium);
  font-size: 15px;
  line-height: 24px;
  letter-spacing: 0;
  color: #fff;
  border: 0;
  margin-top: 0;
  margin-bottom: 0;
}
@media (min-width: 768px) {
  .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay {
    font-weight: var(--fontWeightMedium);
    margin-top: 0;
    margin-bottom: 0;
  }
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__today .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: center 34px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__hovered_span, .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__selected_span {
  background-image: transparent;
  background-color: #000;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__hovered_span .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: var(--DateRangeInput_hoveredOverlayColor);
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__selected_span .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: green;
  transition: all 0.2s ease-out;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__selected_start {
  background-color: #000;
  background-image: none;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__selected_start .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: green;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__after-hovered_start {
  background-color: transparent;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__after-hovered_start .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: var(--DateRangeInput_hoveredOverlayColor);
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__selected_end {
  background-color: #000;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__selected_end .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: green;
  border-top-right-radius: 18px;
  border-bottom-right-radius: 18px;
  color: #fff;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay:hover .renderedDay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 36px;
  background-color: var(--DateRangeInput_hoveredOverlayColor);
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_out_of_range, .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_out_of_range:active, .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_out_of_range:hover {
  background-color: transparent;
  color: #000;
  border: 0;
  opacity: 0.8;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_calendar, .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_calendar:active, .ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_calendar:hover {
  background-color: transparent;
  color: #000;
  border: 0;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarDay__blocked_out_of_range
          .CalendarDay__blocked_calendar
          .renderedDay {
  background-color: transparent;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateInput_fang {
  display: none;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .CalendarMonth_caption {
  text-transform: capitalize;
}
.ShowListingDetails_contentWrapper__NfXEp .ShowListingDetails_orderWrapper__t6iIG .DateInput_input__disabled {
  font-style: normal;
}

.ShowListingDetails_technicalImage__zld2Z p {
  margin-bottom: 6px;
  font-size: 18px;
}
.ShowListingDetails_technicalImage__zld2Z img, .ShowListingDetails_technicalImage__zld2Z embed {
  object-fit: contain;
  object-position: left top;
  width: 280px;
  height: 280px;
}

/* availableAccessories */
.ShowListingDetails_technicalRequirement__QxjiA {
  margin: 120px 0 0;
}
.ShowListingDetails_technicalRequirement__QxjiA .ShowListingDetails_technicalContents__eOCns {
  display: flex;
  gap: 30px;
  justify-content: space-between;
  flex-wrap: wrap;
}
@media (max-width: 1023px) {
  .ShowListingDetails_technicalRequirement__QxjiA .ShowListingDetails_technicalContents__eOCns {
    justify-content: center;
  }
}
.ShowListingDetails_technicalRequirement__QxjiA .ShowListingDetails_technicalContents__eOCns .ShowListingDetails_technicalColumn__Q8\\+5L {
  max-width: calc(33.3333333333% - 30px);
  width: 100%;
}
@media (max-width: 1023px) {
  .ShowListingDetails_technicalRequirement__QxjiA .ShowListingDetails_technicalContents__eOCns .ShowListingDetails_technicalColumn__Q8\\+5L {
    max-width: calc(50% - 30px);
  }
}
@media (max-width: 767px) {
  .ShowListingDetails_technicalRequirement__QxjiA .ShowListingDetails_technicalContents__eOCns .ShowListingDetails_technicalColumn__Q8\\+5L {
    max-width: 100%;
  }
}

.ShowListingDetails_addressText__4m2fy {
  margin-bottom: 12px;
}

.ShowListingDetails_technicalContent__Egytf {
  display: flex;
  align-items: flex-start;
  margin-bottom: 24px;
}
.ShowListingDetails_technicalContent__Egytf svg, .ShowListingDetails_technicalContent__Egytf img {
  width: 24px;
  height: 24px;
  margin-right: 12px;
}
.ShowListingDetails_technicalContent__Egytf h6 {
  font-size: 18px;
  font-weight: 500;
}

/* hospitalityWrapper */
.ShowListingDetails_hospitalityWrapper__c6i5H {
  margin: 120px 0 0;
}
.ShowListingDetails_hospitalityWrapper__c6i5H .ShowListingDetails_hospitalityColumns__vlNjp {
  display: flex;
  justify-content: space-between;
}
.ShowListingDetails_hospitalityWrapper__c6i5H .ShowListingDetails_hospitalityContents__0IwY1 {
  margin-top: 36px;
}
.ShowListingDetails_hospitalityWrapper__c6i5H .ShowListingDetails_hospitalityContents__0IwY1 .ShowListingDetails_hospitalityContent__r4m5Z {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

/* locationWrapper */
.ShowListingDetails_locationWrapper__UtfHJ {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  margin: 120px 0;
}
@media (max-width: 1023px) {
  .ShowListingDetails_locationWrapper__UtfHJ {
    flex-direction: column;
    align-items: flex-start;
  }
}
.ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_locationContents__j2nu- {
  max-width: 300px;
}
.ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_mapContents__mfYyE {
  width: 50%;
}
@media (max-width: 1023px) {
  .ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_mapContents__mfYyE {
    width: 100%;
  }
}
.ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_mapContents__mfYyE img {
  width: 100%;
  height: 100%;
}
.ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_locationContent__3RnOy {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 16px;
}
.ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_locationContent__3RnOy img {
  width: 16px;
  height: 16px;
}
.ShowListingDetails_locationWrapper__UtfHJ .ShowListingDetails_locationContent__3RnOy p {
  font-size: 20px;
}`, "",{"version":3,"sources":["webpack://./src/components/ShowListingDetails/ShowListingDetails.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AACF;AAAE;EAJF;IAKI,eAAA;EAGF;AACF;;AADA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AAIF;AAHE;EAJF;IAKI,eAAA;EAMF;AACF;;AAHE;;;;;EAKE,cAAA;EACA,sBAAA;AAMJ;AAHI;EADF;IAEI,eAAA;EAMJ;AACF;;AAHA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,qBAAA;EACA,gDAAA;AAMF;AALE;EACE,gBAAA;AAOJ;AALE;EACE,YAAA;EACA,WAAA;EACA,oBAAA;EACA,iBAAA;EACA,aAAA;AAOJ;AALE;EACE,eAAA;EACA,eAAA;AAOJ;;AAJA;EACI,kBAAA;EACF,WAAA;AAOF;AANE;EACE,kBAAA;EACA,+CAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;EACA,gBAAA;EACA;;;;;KAAA;AAaJ;AAPI;EACE,sBAAA;AASN;AAPI;EACE,YAAA;EACA,6CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AASN;AARM;EACE,gBAAA;AAUR;;AALA;EACE,wDAAA;AAQF;AAPE;EACE,wDAAA;AASJ;;AANA;EACE,2BAAA;AASF;AARE;EAFF;IAGI,2BAAA;EAWF;AACF;;AATA;EACE,2BAAA;EACA,oCAAA;AAYF;AAXE;EAHF;IAII,2BAAA;EAcF;AACF;;AAZA;EACE,6BAAA;EACA,sBAAA;AAeF;;AAZA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAeF;AAdE;EACE,WAAA;EACA,eAAA;AAgBJ;AAdE;EACE,uBAAA;AAgBJ;AAdE;EACE,sBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AAgBJ;;AAbA;EACE,gBAAA;AAgBF;;AAdA;EACE,eAAA;EACA,gBAAA;AAiBF;;AAfA;EACE,kBAAA;EACA,yBAAA;AAkBF;;AAhBA;EACE,kCAAA;EAAA,6BAAA;EACA,oBAAA;AAmBF;;AAjBA;EACE,aAAA;EAEE,SAAA;AAmBJ;AAlBI;EAJJ;IAKM,SAAA;EAqBJ;AACF;AApBE;EACE,aAAA;AAsBJ;AAjBM;EADF;IAEI,WAAA;IACA,YAAA;EAoBN;AACF;AAlBI;EACE,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;AAoBN;AAnBM;EALF;IAMI,kBAAA;IACA,eAAA;EAsBN;AACF;;AAlBA;EACE,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAqBF;AApBE;EALF;IAMI,eAAA;EAuBF;AACF;;AArBA;EACE,aAAA;EACA,SAAA;EACA,cAAA;EACA,iBAAA;AAwBF;AAvBE;EALF;IAMI,sBAAA;EA0BF;AACF;AAxBE;EACE,yBAAA;AA0BJ;AAzBI;EAFF;IAGI,WAAA;EA4BJ;AACF;AA3BI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AA6BN;AA5BM;EAJF;IAKI,eAAA;EA+BN;AACF;AA7BI;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AA+BN;AA9BM;EAJF;IAKI,eAAA;EAiCN;AACF;AA/BI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;AAiCN;AA/BI;EACE,eAAA;EACA,kBAAA;AAiCN;AAhCM;EAHF;IAII,eAAA;IACF,iBAAA;EAmCJ;AACF;AAhCM;EADF;IAEI,eAAA;EAmCN;AACF;AAjCI;EACE,mBAAA;AAmCN;AAjCI;EACE,mBAAA;AAmCN;AAjCI;EACE,iBAAA;EACA,iBAAA;AAmCN;AAlCM;EACE,kBAAA;AAoCR;AAhCE;EACE,YAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,mBAAA;EACA,wBAAA;EAAA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EAgPA,wCAAA;EAWA,0EAAA;EAuBA,0EAAA;EAeA,0EAAA;EAYA,0EAAA;EAuBA,0EAAA;EASA,0EAAA;AApSJ;AAxCI;EAXF;IAYI,YAAA;EA2CJ;AACF;AA1CI;EAdF;IAeI,aAAA;IACA,WAAA;IACA,cAAA;IACA,gBAAA;EA6CJ;AACF;AA5CI;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AA8CN;AA7CM;EACE,YAAA;AA+CR;AA5CI;EACE,yBAAA;EACA,WAAA;EACA,oBAAA;EACA,gBAAA;AA8CN;AA7CM;EALF;IAMI,gBAAA;EAgDN;AACF;AA/CM;EACE,qBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;AAiDR;AA9CI;EACE,eAAA;AAgDN;AA9CI;EACE,aAAA;EACA,mBAAA;EACA,cAAA;AAgDN;AA9CI;EACE,gBAAA;AAgDN;AA/CM;EACE,eAAA;EACA,kBAAA;AAiDR;AAhDQ;EAHF;IAII,eAAA;EAmDR;AACF;AAjDM;EACE,mBAAA;EACA,gBAAA;AAmDR;AAlDQ;EAHF;IAII,eAAA;EAqDR;AACF;AAnDM;EACE,mBAAA;AAqDR;AAnDM;EACE,iBAAA;EACA,mBAAA;EACA,gBAAA;AAqDR;AAlDI;EACE,UAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AAoDN;AAlDI;EACE,6BAAA;AAoDN;AAlDI;EACE,cAAA;EACA,mBAAA;AAoDN;AAjDI;EACE,gFAAA;EACA,kFAAA;EACA,kCAAA;EACA,oBAAA;EACA,sBAAA;EACA,wBAAA;EACA,yBAAA;AAmDN;AAlDM;EARF;IASI,gFAAA;IACA,kFAAA;IACA,oBAAA;IACA,oBAAA;IACA,WAAA;IACA,+BAAA;IACA,gBAAA;IACA,0BAAA;EAqDN;AACF;AAlDI;EACE,8BAAA;EACA,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EAEA,cAAA;EACA,WAAA;EAEA,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EAEA,gCAAA;AAiDN;AA/CM;EACE,0BAAA;EACA,qBAAA;EACA,gDAAA;EACA,iCAAA;AAiDR;AA9CM;EA1BF;IA2BI,iBAAA;IACA,iBAAA;EAiDN;AACF;AA9CI;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,YAAA;EACA,6BAAA;EACA,mBAAA;EACA,QAAA;AAgDN;AA9CI;EACE,cAAA;EACA,yBAAA;EACA,gBAAA;AAgDN;AA7CI;EACE,kBAAA;EACA,WAAA;AA+CN;AA5CI;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;AA8CN;AA5CM;EACE,UAAA;AA8CR;AA3CM;EACE,WAAA;AA6CR;AAzCI;EACE,WAAA;EACA,SAAA;AA2CN;AAxCI;EAEE,6BAAA;AAyCN;AAvCI;EACE,cAAA;EACA,WAAA;EACA,uBAAA;AAyCN;AAvCI;EACE,WAAA;EACA,SAAA;AAyCN;AAtCI;EACE,qCAAA;EACA,WAAA;AAwCN;AAtCI;EACE,2BAAA;AAwCN;AArCI;EACE,gBAAA;AAuCN;AApCI;EACE,qCAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AAsCN;AApCM;EAPF;IAQI,iBAAA;IACA,aAAA;IACA,gBAAA;EAuCN;AACF;AApCI;EACE,yBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;AAsCN;AApCI;EACE,oCAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,WAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;AAqCN;AAnCM;EAXF;IAYI,oCAAA;IACA,aAAA;IACA,gBAAA;EAsCN;AACF;AAlCI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,yDAAA;EACA,gCAAA;AAoCN;AAhCI;EAEE,6BAAA;EACA,sBAAA;AAiCN;AA/BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;AAiCN;AA/BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;AAiCN;AA9BI;EACE,sBAAA;EACA,sBAAA;AAgCN;AA9BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,4BAAA;EACA,+BAAA;AAgCN;AA7BI;EACE,6BAAA;AA+BN;AA7BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;AA+BN;AA5BI;EACE,sBAAA;AA8BN;AA5BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,6BAAA;EACA,gCAAA;EACA,WAAA;AA8BN;AA5BI;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,2DAAA;AA8BN;AA3BI;EAGE,6BAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;AA2BN;AAxBI;EAGE,6BAAA;EACA,WAAA;EACA,SAAA;AAwBN;AAtBI;;;EAME,6BAAA;AAqBN;AAnBI;EACE,aAAA;AAqBN;AAnBI;EACE,0BAAA;AAqBN;AAlBI;EACE,kBAAA;AAoBN;;AAfE;EACE,kBAAA;EACA,eAAA;AAkBJ;AAhBE;EACE,mBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;AAkBJ;;AAfA,yBAAA;AACA;EACE,iBAAA;AAkBF;AAjBE;EACE,aAAA;EACA,SAAA;EACA,8BAAA;EACA,eAAA;AAmBJ;AAlBI;EALF;IAMI,uBAAA;EAqBJ;AACF;AApBI;EACE,sCAAA;EACA,WAAA;AAsBN;AArBM;EAHF;IAII,2BAAA;EAwBN;AACF;AAvBM;EANF;IAOI,eAAA;EA0BN;AACF;;AAtBA;EACE,mBAAA;AAyBF;;AAvBA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AA0BF;AAzBE;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;AA0BJ;AAxBE;EACE,eAAA;EACA,gBAAA;AA0BJ;;AAvBA,uBAAA;AACA;EACE,iBAAA;AA0BF;AAzBE;EACE,aAAA;EACA,8BAAA;AA2BJ;AAzBE;EACE,gBAAA;AA2BJ;AA1BI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA4BN;;AAxBA,oBAAA;AACA;EACE,aAAA;EACA,qBAAA;EACA,8BAAA;EACA,eAAA;AA2BF;AA1BE;EALF;IAMI,sBAAA;IACA,uBAAA;EA6BF;AACF;AA5BE;EACE,gBAAA;AA8BJ;AA5BE;EACE,UAAA;AA8BJ;AA7BI;EAFF;IAGI,WAAA;EAgCJ;AACF;AA/BI;EACE,WAAA;EACA,YAAA;AAiCN;AA9BE;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,mBAAA;AAgCJ;AA/BI;EACE,WAAA;EACA,YAAA;AAiCN;AA/BI;EACE,eAAA;AAiCN","sourcesContent":[".title {\n  font-size: 36px;\n  margin: 0 0 48px;\n  text-align: center;\n  @media (max-width: 767px) {\n    font-size: 24px;\n  }\n}\n.subTitle {\n  color: #4a4a4f;\n  font-size: 28px;\n  margin: 48px 0 24px;\n  @media (max-width: 767px) {\n    font-size: 20px;\n  }\n}\n.listingDetailsWrapper {\n  p,\n  label,\n  li,\n  h6,\n  h1 {\n    color: #4a4a4f;\n    word-break: break-word;\n  }\n  & p {\n    @media (max-width: 767px) {\n      font-size: 14px;\n    }\n  }\n}\n.selectMenu{\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  letter-spacing: 0.5px;\n  border-top: 1px solid rgba(128, 128, 128, 0.159);\n  &:nth-child(1){\n    border-top: none;\n  }\n  & img{\n    height: 40px;\n    width: 40px;\n    border-radius: 100px;\n    object-fit: cover;\n    margin: 4px 0;\n  }\n  & .genreText{\n    font-size: 12px;\n    margin-top: 6px;\n  }\n}\n.multiSelectBox {\n    position: relative;\n  z-index: 11;\n  & > div {\n    border-radius: 6px;\n    /* border: 1px solid var(--Web-H-3, #538ABE); */\n    color: var(--Black-Shade-Text_Black, #272727);\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n    border-color: #b9b9b9;\n    padding: 1px 8px;\n    /* &:not(:last-child) {\n      min-height: 61px;\n      @media (max-width: 767px) {\n        min-height: 36px;\n      }\n    } */\n    & > div {\n      /* padding: 5px 8px; */\n    }\n    & input {\n      height: auto;\n      color: var(--Black-Shade-Text_Black, #272727);\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      &:focus {\n        box-shadow: none;\n      }\n    }\n  }\n}\n:global(.css-1jqq78o-placeholder){\n  color: var(--Black-Shade-Text_Black, #272727) !important;\n  &::placeholder{\n    color: var(--Black-Shade-Text_Black, #272727) !important;\n  }\n}\n:global(.css-t3ipsp-control){\n  min-height: 48px !important;\n  @media (max-width: 767px) {\n    min-height: 36px !important;\n  }\n}\n:global(.css-13cymwt-control){\n  min-height: 48px !important;\n  border: 1px solid #d8dce6 !important;\n  @media (max-width: 767px) {\n    min-height: 36px !important;\n  }\n}\n:global(.css-1nmdiq5-menu){\n  position: relative !important;\n  z-index: 12 !important;\n}\n\n.timeInputs{\n  width: 100%;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  & select{\n    color: gray;\n    font-size: 16px;\n  }\n  &>div{\n    width: calc(50% - 12px);\n  }\n  & svg{\n    vertical-align: middle;\n    fill: #484848;\n    height: 24px;\n    width: 24px;\n  }\n}\n.boldText {\n  font-weight: 700;\n}\n.reasonLabel{\n  font-size: 16px;\n  font-weight: 700;\n}\n.blur {\n  color: transparent;\n  text-shadow: 0 0 8px #000;\n}\n:global(.Toastify__close-button) {\n  width: fit-content !important;\n  margin: 0 !important;\n}\n.socialContents{\n  display: flex;\n    // flex-direction: column;\n    gap: 20px;\n    @media (max-width: 767px) {\n      gap: 16px;\n    }\n  .socialContent{\n    display: flex;\n    @media (max-width: 1023px) {\n      // flex-direction: column;\n    }\n    & svg{\n      @media (max-width: 767px) {\n        width: 28px;\n        height: 28px;\n      }\n    }\n    & .socialText{\n      margin-bottom: 16px;\n      font-size: 18px;\n      margin-right: 12px;\n      font-weight: 600;\n      @media (max-width: 1023px) {\n        margin-bottom: 8px;\n        font-size: 16px;\n      }\n    }\n  }\n}\n.linkText{\n  color: #4646f3;\n  font-size: 18px;\n  word-break: break-all;\n  font-weight: 600;\n  @media (max-width: 1023px) {\n    font-size: 16px;\n  }\n}\n.contentWrapper {\n  display: flex;\n  gap: 30px;\n  margin: 48px 0;\n  min-height: 300px;\n  @media (max-width: 1023px) {\n    flex-direction: column;\n  }\n\n  & .leftContents {\n    width: calc(100% - 548px);\n    @media (max-width: 1023px) {\n      width: 100%;\n    }\n    & .artistTitle {\n      font-size: 40px;\n      color: #4a4a4f;\n      margin-bottom: 6px;\n      @media (max-width: 767px) {\n        font-size: 28px;\n      }\n    }\n    & .artistName {\n      color: #4a4a4f;\n      font-size: 24px;\n      margin: 16px 0 36px;\n      @media (max-width: 767px) {\n        font-size: 18px;\n      }\n    }\n    & .venueTag {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      margin-top: 36px;\n    }\n    & .artistBio {\n      font-size: 18px;\n      margin: 0px 0 10px;\n      @media (max-width: 767px) {\n        font-size: 16px;\n      margin: 0px 0 6px;\n      }\n    }\n    & h1 {\n      @media (max-width: 767px) {\n        font-size: 24px;\n      }\n    }\n    & h2 {\n      margin: 36px 0 12px;\n    }\n    & h3 {\n      margin: 24px 0 16px;\n    }\n    & ul {\n      list-style: unset;\n      margin-left: 20px;\n      & li {\n        margin-bottom: 6px;\n      }\n    }\n  }\n  & .orderWrapper {\n    width: 500px;\n    margin-left: 48px;\n    background: rgb(242 242 240);\n    padding: 48px 36px;\n    border-radius: 16px;\n    height: fit-content;\n    min-height: 500px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    @media (max-width: 767px) {\n      width: 460px;\n    }\n    @media (max-width: 767px) {\n      padding: 12px;\n      width: 100%;\n      margin-left: 0;\n      background: none;\n    }\n    & .bookButton {\n      background-color: #064749;\n      color: #fff;\n      border-radius: 100px;\n      margin-top: 24px;\n      &:disabled{\n        opacity: 0.4;\n      }\n    }\n    & .calendlyButton {\n      background-color: #064749;\n      color: #fff;\n      border-radius: 100px;\n      margin-top: 16px;\n      @media (max-width: 767px) {\n        margin-top: 12px;\n      }\n      & a {\n        text-decoration: none;\n        color: #fff;\n        width: 100%;\n        height: 100%;\n        display: block;\n      }\n    }\n    & h6 {\n      font-size: 20px;\n    }\n    & .orderContent {\n      display: flex;\n      align-items: center;\n      margin: 16px 0;\n    }\n    & .orderContents {\n      margin: 0 0 32px;\n      & h6 {\n        font-size: 22px;\n        margin-bottom: 8px;\n        @media (max-width: 767px) {\n          font-size: 18px;\n        }\n      }\n      & h1 {\n        margin-bottom: 24px;\n        margin-top: 36px;\n        @media (max-width: 767px) {\n          font-size: 24px;\n        }\n      }\n      & p {\n        margin-bottom: 12px;\n      }\n      & ul {\n        margin-left: 24px;\n        margin-bottom: 12px;\n        list-style: disc;\n      }\n    }\n    & .registeredText {\n      color: red;\n      text-align: center;\n      margin: 16px 0;\n      font-size: 14px;\n    }\n    & .calenderText {\n      margin-bottom: 8px !important;\n    }\n    & :global(.DateRangePicker) {\n      display: block;\n      margin-bottom: 16px;\n    }\n\n    & :global(.DateRangePicker_picker__directionLeft) {\n      /* !important is added to top because react-dates uses inline style for height */\n      /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */\n      box-shadow: var(--boxShadowButton);\n      top: 36px !important;\n      left: unset !important;\n      width: calc(100% - 48px);\n      background-color: #064749;\n      @media (min-width: 768px) {\n        /* !important is added to top because react-dates uses inline style for height */\n        /* Similar problem as in issue: https://github.com/airbnb/react-dates/issues/947 */\n        top: 48px !important;\n        left: 0px !important;\n        width: 100%;\n        min-height: calc(100vh - 252px);\n        min-height: auto;\n        border-radius: 0 0 6px 6px;\n      }\n    }\n\n    & :global(.DateInput_input) {\n      font-family: var(--fontFamily);\n      font-weight: var(--fontWeightMedium);\n      font-size: 16px;\n      line-height: 24px;\n      letter-spacing: -0.1px;\n\n      display: block;\n      width: 100%;\n\n      padding: 6px 12px 4px;\n      margin: 0;\n      border-radius: 6px;\n      border: 1px solid #d8dce6;\n      background-color: #fff;\n      outline: none;\n\n      transition: all 0.1s ease-in-out;\n\n      &:focus {\n        border-radius: 6px 6px 0 0;\n        border-color: #80bdff;\n        box-shadow: 0 0 0 0.2rem rgb(0 123 255 / 25%);\n        transition: all ease-in-out 100ms;\n      }\n\n      @media (min-width: 768px) {\n        line-height: 32px;\n        padding: 7px 16px;\n      }\n    }\n\n    & :global(.DateRangePickerInput) {\n      width: 100%;\n      display: flex;\n      justify-content: space-between;\n      border: none;\n      background-color: transparent;\n      align-items: center;\n      gap: 8px;\n    }\n    & :global(.DayPicker__horizontal) {\n      margin: 0 auto;\n      background-color: #064749;\n      box-shadow: none;\n    }\n\n    & :global(.DayPickerNavigation__horizontal) {\n      position: relative;\n      width: 100%;\n    }\n\n    & :global(.DayPickerNavigation_button__horizontal) {\n      padding: 6px 9px;\n      top: 16px;\n      position: absolute;\n      cursor: pointer;\n      display: inline;\n\n      &:first-of-type {\n        left: 24px;\n      }\n\n      &:last-of-type {\n        right: 24px;\n      }\n    }\n\n    & :global(.DayPickerNavigation_button) {\n      color: #fff;\n      border: 0;\n    }\n\n    & :global(.CalendarMonth),\n    & :global(.CalendarMonthGrid) {\n      background-color: transparent;\n    }\n    & :global(.DateInput) {\n      display: block;\n      width: 100%;\n      background: transparent;\n    }\n    & :global(.DayPicker_weekHeader) {\n      color: #fff;\n      top: 57px;\n    }\n\n    & :global(.DayPicker_weekHeader_li) {\n      font-weight: var(--fontWeightRegular);\n      color: #fff;\n    }\n    & :global(.DayPicker_weekHeader_ul_1) {\n      margin: 10px 0 0 !important;\n    }\n\n    & :global(.DayPicker__withBorder) {\n      border-radius: 0;\n    }\n\n    & :global(.CalendarMonth_caption) {\n      font-weight: var(--fontWeightRegular);\n      font-size: 21px;\n      line-height: 24px;\n      color: #fff;\n      margin: 1px 0 14px;\n\n      @media (min-width: 768px) {\n        line-height: 32px;\n        margin-top: 0;\n        margin-bottom: 0;\n      }\n    }\n\n    & :global(.CalendarDay__default) {\n      background-color: #064749;\n      border: 0;\n      padding: 0;\n      width: 100%;\n      height: 100%;\n    }\n    & :global(.CalendarDay) {\n      font-weight: var(--fontWeightMedium);\n      font-size: 15px;\n      line-height: 24px;\n      letter-spacing: 0;\n\n      color: #fff;\n      border: 0;\n      margin-top: 0;\n      margin-bottom: 0;\n\n      @media (min-width: 768px) {\n        font-weight: var(--fontWeightMedium);\n        margin-top: 0;\n        margin-bottom: 0;\n      }\n    }\n\n    /* Add an underline for '.renderedDay' */\n    & :global(.CalendarDay__today .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-image: url(\"data:image/svg+xml;utf8,<svg width='14' height='2' viewBox='0 0 14 2' xmlns='http://www.w3.org/2000/svg'><path d='M0 0h14v2H0z' fill='%23FFF' fill-rule='evenodd'/></svg>\");\n      background-position: center 34px;\n    }\n\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__hovered_span),\n    & :global(.CalendarDay__selected_span) {\n      background-image: transparent;\n      background-color: #000;\n    }\n    & :global(.CalendarDay__hovered_span .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: var(--DateRangeInput_hoveredOverlayColor);\n    }\n    & :global(.CalendarDay__selected_span .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: green;\n      transition: all 0.2s ease-out;\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__selected_start) {\n      background-color: #000;\n      background-image: none;\n    }\n    & :global(.CalendarDay__selected_start .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: green;\n      border-top-left-radius: calc(36px / 2);\n      border-bottom-left-radius: calc(36px / 2);\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__after-hovered_start) {\n      background-color: transparent;\n    }\n    & :global(.CalendarDay__after-hovered_start .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: var(--DateRangeInput_hoveredOverlayColor);\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__selected_end) {\n      background-color: #000;\n    }\n    & :global(.CalendarDay__selected_end .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: green;\n      border-top-right-radius: calc(36px / 2);\n      border-bottom-right-radius: calc(36px / 2);\n      color: #fff;\n    }\n    & :global(.CalendarDay:hover .renderedDay) {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      width: 100%;\n      height: 36px;\n      background-color: var(--DateRangeInput_hoveredOverlayColor);\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__blocked_out_of_range),\n    & :global(.CalendarDay__blocked_out_of_range:active),\n    & :global(.CalendarDay__blocked_out_of_range:hover) {\n      background-color: transparent;\n      color: #000;\n      border: 0;\n      opacity: 0.8;\n    }\n    /* Remove default bg-color and use our extra span instead '.renderedDay' */\n    & :global(.CalendarDay__blocked_calendar),\n    & :global(.CalendarDay__blocked_calendar:active),\n    & :global(.CalendarDay__blocked_calendar:hover) {\n      background-color: transparent;\n      color: #000;\n      border: 0;\n    }\n    &\n      :global(\n        .CalendarDay__blocked_out_of_range\n          .CalendarDay__blocked_calendar\n          .renderedDay\n      ) {\n      background-color: transparent;\n    }\n    & :global(.DateInput_fang) {\n      display: none;\n    }\n    & :global(.CalendarMonth_caption) {\n      text-transform: capitalize;\n    }\n\n    & :global(.DateInput_input__disabled) {\n      font-style: normal;\n    }\n  }\n}\n.technicalImage{\n  & p{\n    margin-bottom: 6px;\n    font-size: 18px;\n  }\n  & img, & embed{\n    object-fit: contain;\n    object-position: left top;\n    width: 280px;\n    height: 280px;\n  }\n}\n/* availableAccessories */\n.technicalRequirement {\n  margin: 120px 0 0;\n  & .technicalContents {\n    display: flex;\n    gap: 30px;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    @media (max-width: 1023px) {\n      justify-content: center;\n    }\n    & .technicalColumn {\n      max-width: calc(100% / 3 - 30px);\n      width: 100%;\n      @media (max-width: 1023px) {\n        max-width: calc(100% / 2 - 30px);\n      }\n      @media (max-width: 767px) {\n        max-width: 100%;\n      }\n    }\n  }\n}\n.addressText{\n  margin-bottom: 12px;\n}\n.technicalContent {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 24px;\n  & svg,\n  & img {\n    width: 24px;\n    height: 24px;\n    margin-right: 12px;\n  }\n  & h6 {\n    font-size: 18px;\n    font-weight: 500;\n  }\n}\n/* hospitalityWrapper */\n.hospitalityWrapper {\n  margin: 120px 0 0;\n  .hospitalityColumns {\n    display: flex;\n    justify-content: space-between;\n  }\n  & .hospitalityContents {\n    margin-top: 36px;\n    .hospitalityContent {\n      display: flex;\n      align-items: center;\n      gap: 12px;\n      margin-bottom: 12px;\n    }\n  }\n}\n/* locationWrapper */\n.locationWrapper {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  margin: 120px 0;\n  @media (max-width: 1023px) {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  & .locationContents {\n    max-width: 300px;\n  }\n  & .mapContents {\n    width: 50%;\n    @media (max-width: 1023px) {\n      width: 100%;\n    }\n    & img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  & .locationContent {\n    display: flex;\n    gap: 12px;\n    align-items: center;\n    margin-bottom: 16px;\n    & img {\n      width: 16px;\n      height: 16px;\n    }\n    & p {\n      font-size: 20px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": `ShowListingDetails_title__bVIVy`,
	"subTitle": `ShowListingDetails_subTitle__RB32P`,
	"listingDetailsWrapper": `ShowListingDetails_listingDetailsWrapper__deeSz`,
	"selectMenu": `ShowListingDetails_selectMenu__D4-kX`,
	"genreText": `ShowListingDetails_genreText__5Ia3X`,
	"multiSelectBox": `ShowListingDetails_multiSelectBox__AGKTa`,
	"timeInputs": `ShowListingDetails_timeInputs__U6GnX`,
	"boldText": `ShowListingDetails_boldText__8dCyW`,
	"reasonLabel": `ShowListingDetails_reasonLabel__NWyxk`,
	"blur": `ShowListingDetails_blur__awEp9`,
	"socialContents": `ShowListingDetails_socialContents__qclxh`,
	"socialContent": `ShowListingDetails_socialContent__SP4IB`,
	"socialText": `ShowListingDetails_socialText__pxTQX`,
	"linkText": `ShowListingDetails_linkText__1cOZE`,
	"contentWrapper": `ShowListingDetails_contentWrapper__NfXEp`,
	"leftContents": `ShowListingDetails_leftContents__jG3nX`,
	"artistTitle": `ShowListingDetails_artistTitle__tXYb-`,
	"artistName": `ShowListingDetails_artistName__ax3iH`,
	"venueTag": `ShowListingDetails_venueTag__DkLqW`,
	"artistBio": `ShowListingDetails_artistBio__POJXK`,
	"orderWrapper": `ShowListingDetails_orderWrapper__t6iIG`,
	"bookButton": `ShowListingDetails_bookButton__u4FP8`,
	"calendlyButton": `ShowListingDetails_calendlyButton__MCuFg`,
	"orderContent": `ShowListingDetails_orderContent__sQM4h`,
	"orderContents": `ShowListingDetails_orderContents__n6pgK`,
	"registeredText": `ShowListingDetails_registeredText__7Ady1`,
	"calenderText": `ShowListingDetails_calenderText__SANPT`,
	"technicalImage": `ShowListingDetails_technicalImage__zld2Z`,
	"technicalRequirement": `ShowListingDetails_technicalRequirement__QxjiA`,
	"technicalContents": `ShowListingDetails_technicalContents__eOCns`,
	"technicalColumn": `ShowListingDetails_technicalColumn__Q8+5L`,
	"addressText": `ShowListingDetails_addressText__4m2fy`,
	"technicalContent": `ShowListingDetails_technicalContent__Egytf`,
	"hospitalityWrapper": `ShowListingDetails_hospitalityWrapper__c6i5H`,
	"hospitalityColumns": `ShowListingDetails_hospitalityColumns__vlNjp`,
	"hospitalityContents": `ShowListingDetails_hospitalityContents__0IwY1`,
	"hospitalityContent": `ShowListingDetails_hospitalityContent__r4m5Z`,
	"locationWrapper": `ShowListingDetails_locationWrapper__UtfHJ`,
	"locationContents": `ShowListingDetails_locationContents__j2nu-`,
	"mapContents": `ShowListingDetails_mapContents__mfYyE`,
	"locationContent": `ShowListingDetails_locationContent__3RnOy`
};
export default ___CSS_LOADER_EXPORT___;
